import { render, staticRenderFns } from "./SendMethod.vue?vue&type=template&id=11e52fee&scoped=true&"
import script from "./SendMethod.vue?vue&type=script&lang=js&"
export * from "./SendMethod.vue?vue&type=script&lang=js&"
import style0 from "./SendMethod.vue?vue&type=style&index=0&id=11e52fee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e52fee",
  null
  
)

export default component.exports